export const colors = {
  darkGrey: '#3C3C3C',
  grey: '#ADADAD',
  white: '#FCFCFC',
}

export const transition = {
  timingFunction: 'cubic-bezier(.23, 1, .32, 1)',
};

export default {
  colors,
  transition,
}



// WEBPACK FOOTER //
// ./src/components/style.js